export * from './form-of-payment-selection.component';
export * from './form-of-payment-selection.module';